import { locales } from "@luntero/db/contracts/locales";

export function isAdFreePath(pathname: string) {
  const segments = pathname.split("/").filter(Boolean);
  if (locales.some((locale) => locale === segments[0])) segments.shift();
  return segments[0] === "dashboard";
}

export function hasAdsRuntime(document: Document) {
  return document.getElementById("google-adsense") !== null;
}
